<template>
    <form action="">
        <app-form-select-input
            label="Tipo"
            v-model="type.type"
            :options="typeOptions"
            :has-error="$v.type.type.$error"
            error-message="Debe seleccionar el tipo"
            :required="true"
            :is-object="false"
        />
        <app-form-text-input
            label="Nombre"
            v-model="type.name"
            :has-error="$v.type.name.$error"
            error-message="Debe escribir el nombre"
            :required="true"
        />
        <app-form-textarea-input
            label="Descripción"
            v-model="type.description"
        />
    </form>
</template>
<script>
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue';
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue';
import FormTextareaInput from '../../UI/Controls/Forms/FormTextareaInput.vue';
import incidentRiskTypesRepository from '../../../repositories/incident-risk-types.repository';
import { required } from 'vuelidate/lib/validators';

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appFormTextareaInput: FormTextareaInput
    },
    props: {
        selectedType: {
            type: Object,
            default: null
        },
        onSave: {
            type: Function,
            default: () => false
        },
        id: {
            type: String,
            default: () => `incident-risk-type-form-${parseInt(Math.random() * 10000000)}`
        }
    },
    data() {
        return {
            type: {
                id: '',
                type: '',
                name: '',
                description: ''
            },
            typeOptions: [
                { id: 'incidente', name: 'Incidente' },
                { id: 'riesgo', name: 'Riesgo' }
            ]
        };
    },
    watch: {
        selectedType(val) {
            if (val) {
                this.type = {
                    id: val.id,
                    type: val.type,
                    name: val.name,
                    description: val.description || ''
                };
            }
        }
    },
    validations: {
        type: {
            type: { required },
            name: { required }
        }
    },
    methods: {
        clear() {
            this.type = {
                id: '',
                type: '',
                name: '',
                description: ''
            };
            this.$nextTick(() => {
                if (this.$v) {
                    this.$v.$reset();
                }
            });
        },
        async saveType() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error('Debe completar los campos obligatorios');
                return;
            }

            try {
                const payload = {
                    type: this.type.type,
                    name: this.type.name,
                    description: this.type.description || null
                };

                let response;
                if (this.type.id) {
                    response = await incidentRiskTypesRepository.update(this.type.id, payload);
                } else {
                    response = await incidentRiskTypesRepository.save(payload);
                }

                const { data } = response;
                if (data.status) {
                    this.clear();
                    toastr.success(data.msg || 'Información guardada satisfactoriamente');
                    this.onSave();
                } else {
                    toastr.error(data.msg || 'Error al guardar el tipo');
                }
            } catch (error) {
                toastr.error('Ocurrió un error al guardar el tipo');
            }
        }
    },
    created() {
        this.$bus.$on('incident-risk-type-form.save', this.saveType);
        this.$bus.$on(`${this.id}.clear`, this.clear);
    },
    beforeDestroy() {
        this.$bus.$off('incident-risk-type-form.save');
        this.$bus.$off(`${this.id}.clear`);
    }
};
</script>

